export enum ReservationStatus {
  PENDING = 0,
  APPROVED = 1,
  DECLINED = 2,
  CONFIRMED = 3,
  PAYMENT_FAILED = 4,
  CANCELLED = 5,
  CANCELLED_ADMIN = 10,
  EXPIRED = 11,
  CANCELLED_ADMIN_HOST = 53,
  CANCELLED_ADMIN_GUEST = 54,
  COMPLETED = 6,
  EMPTY = 7,
  PRE_APPROVED = 8,
  INQUIRY_EXPIRED = 13,
}

/**
 * Possible response statuses when booking a listing
 */
export enum EBookingStatus {
  SUCCESS = 'BOOKING_SUCCESSFULL',
  FAILURE = 'BOOKING_FAILED',
}
